export default "__VITE_ASSET__Cxrk5Ign__"